import React from 'react'
import pdfLogo from 'images/pdf-logo.png'
import LimitedViewText from './LimitedViewText'
import { getTopThree, getBottomThree } from './helper'

const EssentialLocation = ({
  name,
  limitedView,
  malePersonaName,
  femalePersonaName,
  InterestVsGender,
  photo
}) => {
  console.log(InterestVsGender)
  const content = (
    <React.Fragment>
      <p className="h2 medium text-violet-red x-lg-h1">The Essentials</p>

      <p className="border-bottom border-gallery bw-2 persona-sub-title mb3 pb2">Location</p>

      <div className="flex flex-wrap mxn3">
        <div className="col-4 px3 sm-col-12 sm-mb3">
          <p className="h2 x-lg-h3">In city, the interests can be different</p>
        </div>

        <div className="col-8 px3 sm-col-12">
          <div className="flex flex-wrap fs-18 mxn2 x-lg-h4">
            <div className="col-6 mb2 px2 sm-col-12 sm-mb3">
              {limitedView ?
                <LimitedViewText />
                :
                InterestVsGender.map(insight => (
                  <p>
                    In {insight.locations[0].label}, {femalePersonaName} and females tend to be mostly interested in {insight.metrics.top5_female.map(interest => interest.name).join(', ')}
                  </p>
                ))
              }
            </div>

            <div className="col-6 mb2 px2 sm-col-12">
              {limitedView ?
                <LimitedViewText />
                :
                InterestVsGender.map(insight => (
                  <p>
                    In {insight.locations[0].label}, {malePersonaName} and males tend to be mostly interested in {insight.metrics.top5_male.map(interest => interest.name).join(', ')}
                  </p>
                ))
              }
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );

  return (
    <React.Fragment>
      <section className="section" data-anchor="essentials_by_location">
        <div className="slider-box slider-box--sm-p0 slider-box--pdf-p0 bg-white box-shadow-box flex flex-wrap sm-flex-column-reverse">
          <div className="p4 sm-col-12 sm-px0 sm-py3">
            {content}
          </div>
        </div>
      </section>
    </React.Fragment>
  )
}

export default EssentialLocation
